// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MHC5","type":"styles_type__lb1zZ","choices":"styles_choices__1H3oN"};